import type { ReactNode } from 'react'
import { Navigate, Outlet, useLocation } from 'react-router-dom'

import { useAppSelector } from '@/store/hooks'

interface PublicRouteProps {
  children: ReactNode
}

export function PublicRoute({ children }: PublicRouteProps) {
  const location = useLocation()
  const { isAuthenticated } = useAppSelector((state) => state.auth)
  const from = (location.state as { from?: Location })?.from?.pathname || '/'

  if (isAuthenticated) {
    return <Navigate to={from} replace />
  }

  return children || <Outlet />
}
